import React, { useState, useEffect, useRef } from 'react';
import useVisio from '../hooks/useVisio';
import BoutonAppelVideo from '../components/ui/BoutonAppelVideo';

const SIGNAL_URL = 'https://turn.lepb.fr:3004';
const TRANCHE_AGES = ['Tous âges', '18–25', '26–35', '36–50', '50+'];
const PAYS_LABELS = { fr: 'France', es: 'Espagne', jp: 'Japon', dz: 'Algérie', gb: 'Royaume-Uni', be: 'Belgique', in: 'Inde', br: 'Brésil', us: 'États-Unis', de: 'Allemagne', it: 'Italie', ma: 'Maroc', tn: 'Tunisie', sn: 'Sénégal' };
const PAYS_CODES = { 'france': 'fr', 'espagne': 'es', 'japon': 'jp', 'algerie': 'dz', 'algérie': 'dz', 'royaume-uni': 'gb', 'belgique': 'be', 'inde': 'in', 'bresil': 'br', 'brésil': 'br', 'etats-unis': 'us', 'états-unis': 'us', 'allemagne': 'de', 'italie': 'it', 'maroc': 'ma', 'tunisie': 'tn', 'senegal': 'sn', 'sénégal': 'sn' };

function Drapeau({ code }) {
  return <img src={`https://flagcdn.com/24x18/${code}.png`} alt={code} style={{ width: 16, height: 12, borderRadius: 2, objectFit: 'cover', verticalAlign: 'middle' }} />;
}

function ModalProfil({ profil, onClose, onMessage, onBloquer }) {
  const [signalement, setSignalement] = useState(false);
  const [motif, setMotif] = useState('');
  const [bloque, setBloque] = useState(false);
  const [signalEnvoye, setSignalEnvoye] = useState(false);
  const [dejaSignale, setDejaSignale] = useState(() => { try { return JSON.parse(localStorage.getItem('mjreported') || '[]').includes(profil?.id); } catch { return false; } });

  if (!profil) return null;

  const handleSignaler = async () => {
    if (!motif.trim()) return;
    try {
      const tk = localStorage.getItem('mjtoken');
      await fetch('/api/reports', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tk },
        body: JSON.stringify({ targetType: 'membre', targetId: profil.id, targetLabel: profil.prenom, reason: motif })
      });
    } catch {}
    try { const a = JSON.parse(localStorage.getItem('mjreported') || '[]'); if (!a.includes(profil.id)) { a.push(profil.id); localStorage.setItem('mjreported', JSON.stringify(a)); } } catch {}
    setDejaSignale(true);
    setSignalEnvoye(true);
  };

  const handleBloquer = async () => {
    setBloque(true);
    try {
      const tk = localStorage.getItem('mjtoken');
      await fetch('/api/friends/block/' + profil.id, { method: 'POST', headers: { Authorization: 'Bearer ' + tk } });
    } catch {}
    onBloquer(profil.id);
    setTimeout(onClose, 1200);
  };

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }} style={{ position: 'fixed', inset: 0, background: 'rgba(26,16,16,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 16, maxWidth: 440, width: '100%', border: '2px solid #c49090', boxShadow: '0 20px 60px rgba(139,26,42,0.2)', overflow: 'hidden', position: 'relative' }}>
        <div style={{ height: 80, background: profil.bg, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <button onClick={onClose} style={{ position: 'absolute', top: 10, right: 12, background: 'rgba(255,255,255,0.8)', border: 'none', borderRadius: 20, width: 28, height: 28, cursor: 'pointer', fontSize: 16, color: '#8b1a2a', fontWeight: 700 }}>×</button>
          <div style={{ width: 72, height: 72, borderRadius: '50%', background: profil.couleur, border: '3px solid #fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, fontWeight: 700, color: profil.texte, position: 'absolute', bottom: -22 }}>{profil.initiales}</div>
        </div>
        <div style={{ padding: '32px 24px 24px', textAlign: 'center' }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 20, color: '#1a1010', marginBottom: 4 }}>{profil.prenom}</div>
          <div style={{ fontSize: 13, color: '#6a5050', marginBottom: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }}>
            <Drapeau code={profil.pays} /> {profil.ville} · {profil.age} ans
            <span style={{ marginLeft: 4, width: 8, height: 8, borderRadius: '50%', background: profil.online ? '#2ecc71' : '#ccc', display: 'inline-block' }}></span>
            <span style={{ fontSize: 12, color: profil.online ? '#27ae60' : '#999' }}>{profil.online ? 'En ligne' : 'Hors ligne'}</span>
          </div>
          <span style={{ display: 'inline-block', padding: '3px 12px', borderRadius: 12, fontSize: 12, fontWeight: 700, background: profil.type === 'ami' ? '#f5e8e8' : '#ffe8f0', color: profil.type === 'ami' ? '#8b1a2a' : '#9b2a5a', marginBottom: 12 }}>
            {profil.type === 'ami' ? '🤝 Amitié' : '💑 Amour'}
          </span>
          <p style={{ fontSize: 13, color: '#4a3030', lineHeight: 1.7, marginBottom: 14 }}>{profil.bio}</p>
          <div style={{ marginBottom: 18 }}>{(profil.tags || []).map(t => <span key={t} style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 10, fontSize: 12, background: '#f5eeeb', color: '#6a4040', margin: 2 }}>{t}</span>)}</div>
          <button onClick={() => onMessage(profil)} style={{ width: '100%', padding: '11px', borderRadius: 8, border: 'none', background: '#8b1a2a', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 13, marginBottom: 10 }}>
            ✉️ Envoyer un message
          </button>
          <div style={{ display: 'flex', gap: 8 }}>
            {dejaSignale ? <button disabled style={{ flex: 1, padding: '8px', borderRadius: 8, border: '1.5px solid #c49090', background: '#f5e8e8', color: '#8b1a2a', fontSize: 12, fontWeight: 700, cursor: 'default' }}>✓ Signalé</button> : <button onClick={() => setSignalement(true)} style={{ flex: 1, padding: '8px', borderRadius: 8, border: '1.5px solid #c49090', background: '#fff', color: '#8b4040', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>⚑ Signaler</button>}
            <button onClick={handleBloquer} style={{ flex: 1, padding: '8px', borderRadius: 8, border: '1.5px solid #c49090', background: bloque ? '#f5e8e8' : '#fff', color: '#8b1a2a', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{bloque ? '✓ Bloqué' : '🚫 Bloquer'}</button>
          </div>
        </div>
        {signalement && (
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.97)', borderRadius: 16, padding: '32px 24px', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <button onClick={onClose} style={{ position: 'absolute', top: 10, right: 14, background: 'none', border: 'none', fontSize: 22, color: '#8b1a2a', cursor: 'pointer', fontWeight: 700, lineHeight: 1, zIndex: 2 }}>×</button>
            {signalEnvoye ? (
              <div style={{ textAlign: 'center', marginTop: 60 }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#8b1a2a' }}>Signalement envoyé</div>
                <p style={{ fontSize: 13, color: '#6a5050', marginTop: 8 }}>Un administrateur examinera ce profil.</p>
              </div>
            ) : (
              <>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#8b1a2a' }}>Signaler ce profil</div>
                <p style={{ fontSize: 13, color: '#6a5050' }}>Pourquoi signalez-vous ce profil ?</p>
                {['Comportement inapproprié', 'Faux profil', 'Harcèlement', 'Contenu offensant', 'Autre'].map(m => (
                  <label key={m} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#4a3030', cursor: 'pointer' }}>
                    <input type="radio" name="motif" value={m} onChange={() => setMotif(m)} style={{ accentColor: '#8b1a2a' }} /> {m}
                  </label>
                ))}
                <textarea placeholder="Précisions (optionnel)…" rows={3} style={{ padding: '8px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, resize: 'none' }} />
                <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                  <button onClick={() => setSignalement(false)} style={{ flex: 1, padding: '9px', borderRadius: 8, border: '1.5px solid #c49090', background: '#fff', color: '#8b1a2a', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>Annuler</button>
                  <button onClick={handleSignaler} style={{ flex: 2, padding: '9px', borderRadius: 8, border: 'none', background: motif ? '#8b1a2a' : '#ccc', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>Envoyer le signalement</button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function PopupChat({ profil, onClose }) {
  const token = localStorage.getItem('mjtoken');
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const pseudo = user?.username || 'Anonyme';
  const currentUserId = user?._id || user?.id;

  useEffect(() => {
    if (!profil?.id) return;
    if (!window.__mjOpenChats) window.__mjOpenChats = new Set();
    window.__mjOpenChats.add(String(profil.id));
    return () => { window.__mjOpenChats && window.__mjOpenChats.delete(String(profil.id)); };
  }, [profil?.id]);

  const [conv, setConv] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const bottomRef = useRef(null);
  const signalRef = useRef(null);
  const convRef = useRef(null);

  const visio = useVisio(profil.id, pseudo);

  // Connexion signal pour émettre new-message
  useEffect(() => {
    if (!currentUserId) return;
    import('socket.io-client').then(({ io }) => {
      const socket = io(SIGNAL_URL, { transports: ['websocket'] });
      signalRef.current = socket;
      socket.on('connect', () => {
        socket.emit('visio-register', { userId: currentUserId });
        socket.emit('user-online', { userId: currentUserId });
      });
      socket.on('new-message', ({ fromUserId }) => {
        if (String(fromUserId) !== String(profil.id)) return;
        const c = convRef.current;
        if (!c) return;
        const convId = c._id || c.id;
        fetch('/api/messages/conversations/' + convId + '/messages', { headers: { Authorization: 'Bearer ' + token } })
          .then(r => r.json())
          .then(msgs => { if (Array.isArray(msgs)) setMessages(msgs); })
          .catch(() => {});
      });
    });
    return () => { signalRef.current?.disconnect(); signalRef.current = null; };
  }, [currentUserId]);

  useEffect(() => {
    if (!token || !profil.id) { setLoadError(true); return; }
    let annule = false;
    (async () => {
      try {
        const res = await fetch('/api/messages/conversations/' + profil.id, {
          method: 'POST',
          headers: { Authorization: 'Bearer ' + token }
        });
        if (!res.ok) throw new Error('conv');
        const data = await res.json();
        if (annule) return;
        setConv(data);
        convRef.current = data;
        const convId = data._id || data.id;
        const msgRes = await fetch('/api/messages/conversations/' + convId + '/messages', {
          headers: { Authorization: 'Bearer ' + token }
        });
        const msgs = await msgRes.json();
        if (!annule && Array.isArray(msgs)) setMessages(msgs);
      } catch {
        if (!annule) setLoadError(true);
      }
    })();
    return () => { annule = true; };
  }, [profil.id, token]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const envoyer = async () => {
    if (!input.trim() || !conv || sending) return;
    setSending(true);
    const convId = conv._id || conv.id;
    const fd = new FormData();
    fd.append('text', input);
    try {
      const res = await fetch('/api/messages/conversations/' + convId + '/messages', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token },
        body: fd
      });
      if (res.ok) {
        const msg = await res.json();
        setMessages(prev => [...prev, msg]);
        // Notifier le destinataire via signal server
        if (signalRef.current) {
          signalRef.current.emit('new-message', {
            toUserId: profil.id,
            fromUserId: currentUserId,
            fromPseudo: pseudo,
            preview: input.slice(0, 60)
          });
        }
        setInput('');
      }
    } catch {}
    setSending(false);
  };

  return (
    <div style={{ position: 'fixed', bottom: 24, right: 24, width: 320, background: '#fff', borderRadius: 16, border: '2px solid #c49090', boxShadow: '0 8px 32px rgba(139,26,42,0.18)', zIndex: 2000, overflow: 'hidden' }}>
      <div style={{ background: '#8b1a2a', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: '50%', background: profil.couleur, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: profil.texte, overflow: 'hidden' }}>
          {profil.photo ? <img src={profil.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : profil.initiales}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ color: '#fff', fontWeight: 700, fontSize: 13 }}>{profil.prenom}</div>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: profil.online ? '#2ecc71' : '#ccc', display: 'inline-block' }}></span>
            {profil.online ? 'En ligne' : 'Hors ligne'}
          </div>
        </div>
        <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 20, width: 26, height: 26, cursor: 'pointer', color: '#fff', fontSize: 15, fontWeight: 700 }}>×</button>
      </div>

      <div style={{ padding: '8px 14px', borderBottom: '1px solid #e8d5d0', display: 'flex', justifyContent: 'flex-end' }}>
        <BoutonAppelVideo onClick={visio.visioMode ? visio.stopVisio : visio.startVisio} actif={visio.visioMode} disabled={!profil.id} />
      </div>

      {visio.visioMode && (
        <div style={{ background: '#1a1010', padding: '8px 12px', position: 'relative' }}>
          <video ref={visio.remoteVideoRef} autoPlay playsInline style={{ width: '100%', borderRadius: 8, background: '#000', maxHeight: 160 }} />
          <video ref={visio.localVideoRef} autoPlay playsInline muted style={{ position: 'absolute', bottom: 14, right: 18, width: 60, height: 45, objectFit: 'cover', borderRadius: 4, border: '2px solid #fff' }} />
          <button onClick={visio.toggleMic} style={{ position: 'absolute', bottom: 14, left: 18, padding: '4px 10px', borderRadius: 6, border: 'none', background: visio.micMuted ? '#8b1a2a' : 'rgba(0,0,0,0.55)', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{visio.micMuted ? 'Muet' : 'Micro'}</button>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, textAlign: 'center', marginTop: 4 }}>{visio.visioStatus}{visio.callTime > 0 ? ' · ' + visio.formatTime(visio.callTime) : ''}</div>
        </div>
      )}

      <div style={{ height: 220, overflowY: 'auto', padding: '10px 14px', display: 'flex', flexDirection: 'column', gap: 8, background: '#fafaf8' }}>
        {loadError && <div style={{ textAlign: 'center', color: '#c03030', fontSize: 12, marginTop: 20 }}>Impossible de charger la conversation.</div>}
        {!loadError && messages.length === 0 && <div style={{ textAlign: 'center', color: '#9a8080', fontSize: 12, marginTop: 20, fontStyle: 'italic' }}>Début de la conversation…</div>}
        {messages.map((m, i) => {
          const isMe = m.sender?._id === currentUserId || m.sender === currentUserId;
          const heure = m.createdAt ? new Date(m.createdAt).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '';
          return (
            <div key={m._id || i} style={{ display: 'flex', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
              <div style={{ maxWidth: '75%', background: isMe ? '#8b1a2a' : '#f5eeeb', color: isMe ? '#fff' : '#1a1010', borderRadius: isMe ? '12px 12px 4px 12px' : '12px 12px 12px 4px', padding: '8px 12px', fontSize: 12, lineHeight: 1.5 }}>
                {m.text}
                {m.imageUrl && <img src={m.imageUrl} alt="" style={{ maxWidth: 150, borderRadius: 8, display: 'block', marginTop: m.text ? 4 : 0 }} />}
                <div style={{ fontSize: 12, color: isMe ? 'rgba(255,255,255,0.6)' : '#999', marginTop: 3, textAlign: 'right' }}>{heure}</div>
              </div>
            </div>
          );
        })}
        <div ref={bottomRef} />
      </div>

      <div style={{ padding: '10px 12px', borderTop: '1.5px solid #e8d5d0', display: 'flex', gap: 8 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && envoyer()}
          placeholder="Écrire un message…"
          disabled={!conv}
          style={{ flex: 1, padding: '8px 12px', borderRadius: 20, border: '1.5px solid #c49090', fontSize: 12, outline: 'none' }}
        />
        <button onClick={envoyer} disabled={!conv || sending} style={{ padding: '8px 14px', borderRadius: 20, border: 'none', background: '#8b1a2a', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer', opacity: (!conv || sending) ? 0.6 : 1 }}>→</button>
      </div>
    </div>
  );
}

export default function RencontresFans() {
  const [typeFiltre, setTypeFiltre] = useState('tous');
  const [ageFiltre, setAgeFiltre] = useState('Tous âges');
  const [recherche, setRecherche] = useState('');
  const [filterPays, setFilterPays] = useState('');
  const [filterSexe, setFilterSexe] = useState('');
  const [filterOrientation, setFilterOrientation] = useState('');
  const [profilOuvert, setProfilOuvert] = useState(null);
  const [chatOuvert, setChatOuvert] = useState(null);
  const [bloques, setBloques] = useState([]);
  const [showBlocked, setShowBlocked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formProfil, setFormProfil] = useState({ prenom: '', ville: '', age: '', sexe: 'F', typeRecherche: 'ami', orientation: '', bio: '', tags: '' });
  const [profilSaved, setProfilSaved] = useState(false);
  const [friendRequests, setFriendRequests] = useState({ sent: [] });
  const [profiles, setProfiles] = useState([]);
  const [onlineUserIds, setOnlineUserIds] = useState([]);

  // Socket pour statut en ligne
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (!user) return;
    const userId = user._id || user.id;
    let socket;
    import('socket.io-client').then(({ io }) => {
      socket = io(SIGNAL_URL, { transports: ['websocket'] });
      socket.on('connect', () => {
        socket.emit('visio-register', { userId });
        socket.emit('user-online', { userId });
        socket.emit('get-online-users');
      });
      socket.on('online-users', (userIds) => {
        setOnlineUserIds(userIds);
      });
    });
    return () => { socket?.disconnect(); };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('mjtoken');
    if (!token) return;
    fetch('/api/friends/mine', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json()).then(data => setFriendRequests(data)).catch(() => {});
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('mjtoken');
    if (!token) return;
    fetch('/api/friends/blocked', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setBloques(data); }).catch(() => {});
  }, []);

  const handleAddFriend = async (userId) => {
    const token = localStorage.getItem('mjtoken');
    if (!token) return alert('Vous devez etre connecte.');
    await fetch('/api/friends/request/' + userId, { method: 'POST', headers: { Authorization: 'Bearer ' + token } });
    setFriendRequests(p => ({ ...p, sent: [...(p.sent || []), { userId }] }));
  };

  const handleDebloquer = async (userId) => {
    const token = localStorage.getItem('mjtoken');
    try {
      await fetch('/api/friends/unblock/' + userId, { method: 'POST', headers: { Authorization: 'Bearer ' + token } });
    } catch {}
    setBloques(prev => prev.filter(x => String(x) !== String(userId)));
  };

  useEffect(() => {
    fetch('/api/auth/rencontres')
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) {
          const mapped = data.map(u => ({
            id: u._id,
            prenom: u.username,
            pays: PAYS_CODES[u.country?.toLowerCase()] || u.country?.toLowerCase().slice(0, 2) || 'fr',
            ville: u.ville || '',
            age: u.age || '?',
            sexe: u.sexe || 'autre',
            orientation: u.orientation || '',
            type: u.typeRecherche || 'ami',
            initiales: (u.username || 'U').slice(0, 2).toUpperCase(),
            couleur: '#e8c0c8',
            texte: '#8b1a2a',
            bg: '#f5e8e8',
            tags: u.tags || [],
            bio: u.bio || '',
            online: false,
            photo: u.photo || null
          }));
          setProfiles(mapped);
        }
      })
      .catch(() => {});
  }, []);

  // Mettre à jour online sur les profils dès que onlineUserIds change
  const profilesWithOnline = profiles.map(p => ({ ...p, online: onlineUserIds.includes(String(p.id)) }));

  const filtres = profilesWithOnline.filter(p => {
    if (bloques.includes(p.id)) return false;
    if (typeFiltre !== 'tous' && p.type !== typeFiltre) return false;
    if (ageFiltre !== 'Tous âges') {
      const a = p.age;
      if (ageFiltre === '18–25' && !(a >= 18 && a <= 25)) return false;
      if (ageFiltre === '26–35' && !(a >= 26 && a <= 35)) return false;
      if (ageFiltre === '36–50' && !(a >= 36 && a <= 50)) return false;
      if (ageFiltre === '50+' && a < 50) return false;
    }
    if (recherche && !p.prenom.toLowerCase().includes(recherche.toLowerCase()) && !p.ville.toLowerCase().includes(recherche.toLowerCase()) && !PAYS_LABELS[p.pays]?.toLowerCase().includes(recherche.toLowerCase())) return false;
    if (filterPays && p.pays !== filterPays) return false;
    if (filterSexe && p.sexe !== filterSexe) return false;
    if (filterOrientation && p.orientation !== filterOrientation) return false;
    return true;
  });

  const btnF = (actif, onClick, label) => (
    <button onClick={onClick} style={{ padding: '7px 14px', borderRadius: 8, border: actif ? '2px solid #8b1a2a' : '2px solid #e8d5d0', background: actif ? '#8b1a2a' : '#fff', color: actif ? '#fff' : '#4a3030', fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
      {label}
    </button>
  );

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh', fontFamily: 'Arial,sans-serif' }}>
      <div style={{ background: '#fff', padding: '48px 48px 36px', borderBottom: '2px solid #c49090' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', marginBottom: 6, fontWeight: 700 }}>RENCONTRES FANS</div>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
            <div>
              <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 30, color: '#1a1010', fontWeight: 400, marginBottom: 8 }}>
                Trouver des fans, <em style={{ color: '#8b1a2a', fontStyle: 'italic' }}>partager la passion</em>
              </h1>
              <p style={{ fontSize: 13, color: '#4a3030', lineHeight: 1.8, maxWidth: 500 }}>
                Amis, âmes sœurs, partenaires de concerts… Rencontrez d'autres fans de Michael Jackson du monde entier.
              </p>
            </div>
            <button onClick={() => setShowModal(true)} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 10, padding: '12px 24px', fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
              💑 Créer mon profil
            </button>
          </div>
          <input value={recherche} onChange={e => setRecherche(e.target.value)} placeholder="Rechercher par pseudo, ville, région…" style={{ marginTop: 16, width: '100%', maxWidth: 420, padding: '9px 14px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#4a3030', background: '#fff', outline: 'none', boxSizing: 'border-box' }} />
          <div style={{ marginTop: 10, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <select value={filterPays} onChange={e => setFilterPays(e.target.value)}
              style={{ padding: '9px 14px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#4a3030', background: '#fff', outline: 'none', minWidth: 180 }}>
              <option value="">🌍 Tous les pays</option>
              {Object.entries(PAYS_LABELS).sort((a, b) => a[1].localeCompare(b[1])).map(([code, nom]) => (
                <option key={code} value={code}>{nom}</option>
              ))}
            </select>
            <select value={filterSexe} onChange={e => setFilterSexe(e.target.value)}
              style={{ padding: '9px 14px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#4a3030', background: '#fff', outline: 'none', minWidth: 160 }}>
              <option value="">👥 Tous</option>
              <option value="F">♀ Femmes</option>
              <option value="H">♂ Hommes</option>
              <option value="autre">⚥ Autre</option>
            </select>
            <select value={filterOrientation} onChange={e => setFilterOrientation(e.target.value)}
              style={{ padding: '9px 14px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#4a3030', background: '#fff', outline: 'none', minWidth: 180 }}>
              <option value="">Toutes orientations</option>
              <option value="hetero">Hétérosexuel(le)</option>
              <option value="homo">Homosexuel(le)</option>
              <option value="bi">Bisexuel(le)</option>
              <option value="pan">Pansexuel(le)</option>
              <option value="asexuel">Asexuel(le)</option>
              <option value="autre">Autre</option>
            </select>
          </div>
          <div style={{ display: 'flex', gap: 28, marginTop: 18 }}>
            {[{ n: profilesWithOnline.length, l: 'fans inscrits' }, { n: new Set(profilesWithOnline.map(p => p.pays)).size, l: 'pays' }, { n: profilesWithOnline.filter(p => p.online).length, l: 'en ligne maintenant' }].map(({ n, l }) => (
              <div key={l}><span style={{ fontSize: 20, fontWeight: 700, color: '#8b1a2a', fontFamily: 'Georgia,serif' }}>{n}</span><span style={{ fontSize: 12, color: '#6a5050', marginLeft: 5 }}>{l}</span></div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ background: '#f5eeeb', borderBottom: '2px solid #c49090', padding: '16px 48px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, color: '#1a1010', fontWeight: 700, minWidth: 90 }}>Je cherche :</span>
            {bloques.length > 0 && <button onClick={() => setShowBlocked(true)} style={{ marginLeft: 'auto', padding: '7px 14px', borderRadius: 8, border: '1.5px solid #8b1a2a', background: '#fff', color: '#8b1a2a', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Bloqués ({bloques.length})</button>}
            {btnF(typeFiltre === 'tous', () => setTypeFiltre('tous'), 'Tous')}
            {btnF(typeFiltre === 'ami', () => setTypeFiltre('ami'), '🤝 Des amis')}
            {btnF(typeFiltre === 'amour', () => setTypeFiltre('amour'), "💑 L'amour")}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, color: '#1a1010', fontWeight: 700, minWidth: 90 }}>Âge :</span>
            {TRANCHE_AGES.map(a => btnF(ageFiltre === a, () => setAgeFiltre(a), a))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: "40px 48px" }}>
        {filtres.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 0', color: '#8b1a2a', fontSize: 15 }}>Aucun profil pour ces filtres.</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 22 }}>
            {filtres.map(p => (
              <div key={p.id} onClick={() => setProfilOuvert(p)}
                style={{ background: '#fff', borderRadius: 12, border: '1.5px solid #e8d5d0', overflow: 'hidden', cursor: 'pointer', transition: 'box-shadow 0.2s', boxShadow: '0 2px 8px rgba(139,26,42,0.06)' }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 24px rgba(139,26,42,0.13)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(139,26,42,0.06)'}
              >
                <div style={{ height: 80, background: p.bg, position: 'relative' }}>
                  <div style={{ width: 60, height: 60, borderRadius: '50%', background: p.couleur, border: '3px solid #fff', position: 'absolute', bottom: -20, left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 700, color: p.texte, overflow: 'hidden' }}>
                    {p.photo ? <img src={p.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : p.initiales}
                  </div>
                  {p.online && <span style={{ position: 'absolute', top: 8, right: 10, width: 9, height: 9, borderRadius: '50%', background: '#2ecc71', border: '2px solid #fff' }}></span>}
                </div>
                <div style={{ padding: '28px 14px 16px', textAlign: 'center' }}>
                  <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#1a1010', marginBottom: 3 }}>{p.prenom}</div>
                  <div style={{ fontSize: 12, color: '#6a5050', marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }}>
                    <Drapeau code={p.pays} /> {p.ville} · {p.age} ans · {p.sexe === 'F' ? '♀ Femme' : p.sexe === 'H' ? '♂ Homme' : '⚥ Autre'}
                  </div>
                  <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 700, background: p.type === 'ami' ? '#f5e8e8' : '#ffe8f0', color: p.type === 'ami' ? '#8b1a2a' : '#9b2a5a', marginBottom: 10 }}>
                    {p.type === 'ami' ? '🤝 Amitié' : '💑 Amour'}
                  </span>
                  {(() => {
                    const O = { hetero:{l:'Hétérosexuel(le)',c:'#185FA5'}, homo:{l:'Homosexuel(le)',c:'#3B6D11'}, bi:{l:'Bisexuel(le)',c:'#534AB7'}, pan:{l:'Pansexuel(le)',c:'#BA7517'}, asexuel:{l:'Asexuel(le)',c:'#993556'}, autre:{l:'Autre',c:'#5F5E5A'} }[p.orientation];
                    return O ? <div style={{ fontSize: 12, fontWeight: 700, color: O.c, marginTop: 6 }}>♥ {O.l}</div> : null;
                  })()}
                  <div style={{ marginBottom: 12 }}>{(p.tags || []).map(t => <span key={t} style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 12, background: '#f5eeeb', color: '#6a4040', margin: 2 }}>{t}</span>)}</div>
                  <button onClick={e => { e.stopPropagation(); setProfilOuvert(p); }} style={{ width: '100%', padding: '8px', borderRadius: 8, border: 'none', background: '#8b1a2a', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12, marginBottom: 6 }}>Voir le profil</button>
                  <button onClick={e => { e.stopPropagation(); handleAddFriend(p.id); }}
                    disabled={friendRequests.sent?.some(s => s.userId === p.id || s.userId?.toString() === p.id?.toString())}
                    style={{ width: '100%', padding: '6px', borderRadius: 8, border: '1px solid #c49090', background: '#fff', color: friendRequests.sent?.some(s => s.userId === p.id || s.userId?.toString() === p.id?.toString()) ? '#9a8080' : '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>
                    {friendRequests.sent?.some(s => s.userId === p.id || s.userId?.toString() === p.id?.toString()) ? 'Demande envoyee' : '+ Ajouter en ami'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        {showBlocked && bloques.length > 0 && (
          <div style={{ position: 'fixed', top: 0, right: 0, height: '100vh', width: 300, background: '#fff', borderLeft: '2px solid #c49090', boxShadow: '-8px 0 32px rgba(0,0,0,0.15)', zIndex: 1600, display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '16px 20px', background: '#8b1a2a', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ color: '#fff', fontFamily: 'Georgia,serif', fontSize: 16 }}>Membres bloqués ({bloques.length})</span>
              <button onClick={() => setShowBlocked(false)} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 16, width: 26, height: 26, color: '#fff', fontSize: 15, cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
              {profilesWithOnline.filter(pp => bloques.includes(pp.id)).map(pp => (
                <div key={pp.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', border: '1px solid #e8d5d0', borderRadius: 10, background: '#fafaf8' }}>
                  <div style={{ width: 34, height: 34, borderRadius: '50%', background: pp.couleur, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: pp.texte, overflow: 'hidden', flexShrink: 0 }}>
                    {pp.photo ? <img src={pp.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : pp.initiales}
                  </div>
                  <span style={{ flex: 1, fontSize: 13, color: '#1a1010' }}>{pp.prenom}</span>
                  <button onClick={() => handleDebloquer(pp.id)} style={{ padding: '5px 10px', borderRadius: 8, border: '1px solid #8b1a2a', background: '#fff', color: '#8b1a2a', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>Débloquer</button>
                </div>
              ))}
              {bloques.filter(id => !profilesWithOnline.some(pp => pp.id === id)).map(id => (
                <div key={id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', border: '1px solid #e8d5d0', borderRadius: 10, background: '#fafaf8' }}>
                  <span style={{ flex: 1, fontSize: 12, color: '#9a8080', fontStyle: 'italic' }}>Membre indisponible</span>
                  <button onClick={() => handleDebloquer(id)} style={{ padding: '5px 10px', borderRadius: 8, border: '1px solid #8b1a2a', background: '#fff', color: '#8b1a2a', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>Débloquer</button>
                </div>
              ))}
            </div>
          </div>
        )}
        <div style={{ marginTop: 48, padding: '28px 32px', background: '#fff', border: '2px solid #c49090', borderRadius: 14, textAlign: 'center' }}>
          <div style={{ fontSize: 28, color: '#8b1a2a', marginBottom: 8 }}>"</div>
          <p style={{ fontFamily: 'Georgia,serif', fontSize: 17, color: '#3a2020', lineHeight: 1.7, fontStyle: 'italic' }}>In a world filled with hate, we must still dare to hope. In a world filled with anger, we must still dare to comfort.</p>
          <div style={{ fontSize: 12, color: '#8b1a2a', marginTop: 10, fontWeight: 600, letterSpacing: '0.1em' }}>— MICHAEL JACKSON</div>
        </div>
      </div>

      {profilOuvert && <ModalProfil profil={profilOuvert} onClose={() => setProfilOuvert(null)} onMessage={p => { setProfilOuvert(null); setChatOuvert(p); }} onBloquer={id => setBloques(prev => [...prev, id])} />}
      {chatOuvert && <PopupChat profil={chatOuvert} onClose={() => setChatOuvert(null)} />}

      {showModal && (
        <div onClick={e => { if (e.target === e.currentTarget) setShowModal(false); }} style={{ position: 'fixed', inset: 0, background: 'rgba(26,16,16,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: '36px 32px', maxWidth: 460, width: '100%', border: '2px solid #c49090', boxShadow: '0 20px 60px rgba(139,26,42,0.2)' }}>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 22, color: '#8b1a2a', marginBottom: 6 }}>Créer mon profil</div>
            <p style={{ fontSize: 13, color: '#6a5050', marginBottom: 20, lineHeight: 1.6 }}>Rejoignez la communauté des fans de Michael Jackson.</p>
            {profilSaved ? (
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div style={{ fontSize: 36, marginBottom: 10 }}>✅</div>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#8b1a2a' }}>Profil cree !</div>
              </div>
            ) : (
              <>
                {[{ label: 'Prenom', ph: 'Votre prenom', key: 'prenom' }, { label: 'Ville', ph: 'Votre ville', key: 'ville' }, { label: 'Age', ph: 'Votre age', key: 'age' }].map(f => (
                  <div key={f.key} style={{ marginBottom: 14 }}>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>{f.label}</label>
                    <input value={formProfil[f.key]} onChange={e => setFormProfil(p => ({ ...p, [f.key]: e.target.value }))} placeholder={f.ph} style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010', boxSizing: 'border-box' }} />
                  </div>
                ))}
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Sexe</label>
                  <select value={formProfil.sexe} onChange={e => setFormProfil(p => ({ ...p, sexe: e.target.value }))} style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010' }}>
                    <option value="F">Femme</option>
                    <option value="H">Homme</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Je cherche</label>
                  <select value={formProfil.typeRecherche} onChange={e => setFormProfil(p => ({ ...p, typeRecherche: e.target.value }))} style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010' }}>
                    <option value="ami">Des amis</option>
                    <option value="amour">L'amour</option>
                  </select>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Orientation (facultatif)</label>
                  <select value={formProfil.orientation} onChange={e => setFormProfil(p => ({ ...p, orientation: e.target.value }))} style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010' }}>
                    <option value="">Non précisé</option>
                    <option value="hetero">Hétérosexuel(le)</option>
                    <option value="homo">Homosexuel(le)</option>
                    <option value="bi">Bisexuel(le)</option>
                    <option value="pan">Pansexuel(le)</option>
                    <option value="asexuel">Asexuel(le)</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Ma bio</label>
                  <textarea rows={3} value={formProfil.bio} onChange={e => setFormProfil(p => ({ ...p, bio: e.target.value }))} placeholder="Parlez de votre passion pour Michael..." style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010', resize: 'none', boxSizing: 'border-box' }} />
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Mes centres d'interet (separes par des virgules)</label>
                  <input value={formProfil.tags} onChange={e => setFormProfil(p => ({ ...p, tags: e.target.value }))} placeholder="Ex: Thriller era, Danse, Concerts" style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010', boxSizing: 'border-box' }} />
                </div>
              </>
            )}
            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              <button onClick={() => setShowModal(false)} style={{ flex: 1, padding: '11px', borderRadius: 8, border: '2px solid #c49090', background: '#fff', color: '#8b1a2a', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>Annuler</button>
              <button onClick={async () => {
                const token = localStorage.getItem('mjtoken');
                if (!token) return alert('Vous devez etre connecte pour creer un profil.');
                const tags = formProfil.tags.split(',').map(t => t.trim()).filter(Boolean);
                const res = await fetch('/api/auth/profil-rencontres', {
                  method: 'PATCH',
                  headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
                  body: JSON.stringify({ ...formProfil, tags, profilPublic: true })
                });
                if (res.ok) { setProfilSaved(true); setTimeout(() => { setShowModal(false); setProfilSaved(false); }, 2000); }
              }} style={{ flex: 2, padding: '11px', borderRadius: 8, border: 'none', background: '#8b1a2a', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>Créer mon profil</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
